async function autoAddToCart() {
  const fetchCart = await fetch('/cart.js'),
  cartData = await fetchCart.json();

  let items = [];

  for(let i = 0; i < window.autoAddToCartBlocks.length; i++) {
    let products = window.autoAddToCartBlocks[i].products,
    triggerUrl = window.autoAddToCartBlocks[i]?.trigger_url,
    isUrlMatch = triggerUrl === (window.location.origin + window.location.pathname) || triggerUrl === window.location.pathname,
    isCustomerOnly = window.autoAddToCartBlocks[i]?.is_customer_only,
    isCustomer = window.isCustomer;

    if(isUrlMatch && (!isCustomerOnly || (isCustomerOnly && isCustomer))) {
        products.forEach(product => {
          let currentCartItemsQuantities = cartData.items.filter(item => item.id === Number(product.variant_id)).map(item => Number(item.quantity)).reduce((a, b) => a + b, 0),
          productQuantity = Number(product.quantity);

          if(currentCartItemsQuantities < productQuantity) {
            let quantityToAdd = productQuantity - currentCartItemsQuantities;
            items.push({ id: product.variant_id, quantity: quantityToAdd });
          }
        });

        if(items.length > 0) {
          Cart.sendAddToCart(items, false);
        }

        break;
    }
  }
}

window.addEventListener("load", autoAddToCart);